import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import Table from 'react-bootstrap/Table';
import AccuracyBadgeWithTooltip from "../../accuracy-badge-with-tooltip";
import { TOOL_ACCURACY, TOOL_ACCURACY_INCREASE, TOOL_ACCURACY_TOOLTIP } from "../../../helpers/accuracy";

const StyledContainer = styled(Container)`
  .table-responsive {
    overflow-x: auto;
  }
  .table {
    margin-bottom: 1rem;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
  }
  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
  }
  .table tbody + tbody {
    border-top: 2px solid #dee2e6;
  }
  .table-striped > tbody > tr:nth-of-type(odd) > * {
    --bs-table-accent-bg:#d0dfeb !important;
    color: var(--bs-table-striped-color);
    border-color: #9daac7 !important;
}
.table-shadow {
     box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
     border-radius:10px;
  }
  a {
    color: #ffa700!important;
  }
  a:hover {
    color: gray!important;
  }
  @media(max-width: 574px) {
    .table-responsive {
      width: 100%;
    }
  }

`

const Features = () => {

    return (
        <StyledContainer>
            <div className="table-responsive">
                <Table striped bordered hover className="table">
                    <thead>
                        <tr>
                            <th className="fw-bolder">Features</th>
                            <th className="fw-bolder">Clearout</th>
                            <th className="fw-bolder">Dropcontact</th>
                        </tr>
                    </thead>
                    <tbody>
              <tr>
                            <td className="fw-bolder">Accuracy</td>
                <td><AccuracyBadgeWithTooltip
              accuracy={TOOL_ACCURACY}
              increase={TOOL_ACCURACY_INCREASE}
              tooltipText={TOOL_ACCURACY_TOOLTIP}
            /></td>
                            <td>Undisclosed</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">LinkedIn Scraping</td>
                            <td>Yes</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Phone Number Enrichment</td>
                            <td>Line Type, Carrier, Timezone, E164 & International Formatting, etc</td>
                            <td>No (Only Email Address)</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Pricing</td>
                            <td>Starts from $21 for 3000 Credits</td>
                            <td>Starts with €34 for 1000 Requests/Month<br></br>(Credits Carry Over Only on Subscription)</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Credit Validity</td>
                            <td>Lifetime</td>
                            <td>30 Days Only</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Payment Plan</td>
                            <td>Pay-As-You-Go & Subscription</td>
                            <td>Subscription Only</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Team Account</td>
                            <td>Yes</td>
                            <td>No</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Find Personal Email Address</td>
                            <td>Yes</td>
                            <td>No (Only Business Emails)</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Deduplication</td>
                            <td>No</td>
                            <td>Charges for Duplicates</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Free Credits</td>
                            <td>100</td>
                            <td>100 Free Credits Per Month</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Credits</td>
                            <td>4 Credits per non Role-based Email / 2 Credits per Role-based Email<br /> & 2 Credits for Phone Number</td>
                            <td>1 Credit = 1 File Row or 1 API Request</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Real-Time In-App Search</td>
                            <td>Yes</td>
                            <td>No (Only Database Lookup)</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Real-Time Search</td>
                            <td>Yes</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Download File Type</td>
                            <td>.CSV, Google Sheets</td>
                            <td>.XLSX, .TXT, .CSV</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Pre-Verified Results</td>
                            <td>Yes</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">CRM Integration</td>
                            <td>Google Sheets</td>
                            <td>Yes</td>
                        </tr>
                        <tr>
                            <td className="fw-bolder">Company Size</td>
                            <td>Yes</td>
                            <td>Yes</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </StyledContainer>
    )
}

export default Features;